module.exports = __webpack_public_path__ + "img/t1-5.35413ed4.svg";